import { LOCATION_ORIGIN } from '../../call-api';
import { getFullMenu } from './Header/helpers';

/** Toolbar item with `name === 'logout'` (merged from `LogoutMenuItem` in MenuConfig). */
export function findLogoutItem(menuItems) {
  const toolbar = getFullMenu(menuItems || []).find(g => g.name === 'toolbar');
  if (!toolbar || !toolbar.items) {
    return null;
  }
  return toolbar.items.find(i => i.name === 'logout');
}

/** Same Engage host as the app (dv / qa / ua / prod); mirrors NfibComHeader. */
export function buildLoginHref() {
  const base = (LOCATION_ORIGIN || window.location.origin || '').replace(
    /\/$/,
    ''
  );
  const ret = encodeURIComponent(`${base}/account`);
  return `${LOCATION_ORIGIN}/auth/login?returnUrl=${ret}`;
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/headerLoginLogoutUtils.js